import { atom } from 'recoil';

/**
 * @desc 메뉴 뱃지 표시를 위한 타임스탬프 데이터
 * - API로부터 가져온 각 콘텐츠 타입별 생성일/수정일 정보
 */
export const timestampsState = atom({
  key: 'timestampsState',
  default: null,
});

/**
 * @desc 왼쪽 사이드바 메뉴 정보
 */
export const leftSideBarState = atom({
  key: 'leftSideBarState',
  default: {
    title: '',
    path: '',
    lnb: [],
  },
});

/**
 * @desc 페이지 내 목차 네비게이션 정보
 */
export const tocNavigationState = atom({
  key: 'tocNavigationState',
  default: {
    title: '',
    items: [],
  },
});
